import { Outlet } from 'react-router-dom';

/**
 * RootLayout — outermost shell rendered for every route. Currently a pass
 * -through <Outlet>; this is the place to mount anything that must persist
 * across the entire app (e.g. global modals, scroll restoration).
 */
export default function RootLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Outlet />
    </div>
  );
}
